import * as actionTypes from "./actionTypes";
import * as types from "./types";

//Post Override Request
export const postOverrideRequest = (params: types.IOverrideRequestPostPayload[]): types.PostOverrideRequest => ({
    type: actionTypes.POST_OVERRIDEREQUEST_REQUEST,
    payload: params
});

export const postOverrideSuccess = (payload: types.IPostOverrideSuccessPayload): types.PostOverrideSuccess => ({
    type: actionTypes.POST_OVERRIDEREQUEST_SUCCESS,
    payload
});

export const postOverrideFailure = (payload: types.IPostOverrideFailurePayload): types.PostOverrideFailure => ({
    type: actionTypes.POST_OVERRIDEREQUEST_FAILURE,
    payload
});


//Patch Override Request
export const patchOverrideRequest = (requestId: string, payload: types.IPatchOverRequestPayload): types.PatchOverrideRequest => ({
    type: actionTypes.PATCH_OVERRIDEREQUEST_REQUEST,
    requestId,
    payload
});

export const patchOverrideSuccess = (success: types.IPatchOverrideRequestSuccessPayload): types.PatchOverrideRequestSuccess => ({
    type: actionTypes.PATCH_OVERRIDEREQUEST_SUCCESS,
    success
});

export const patchOverrideFailure = (payload: types.IPatchOverrideRequestFailurePayload): types.PatchOverrideRequestFailure => ({
    type: actionTypes.PATCH_OVERRIDEREQUEST_FAILURE,
    payload
});

//Get Override Request
export const getOverrideRequest = (params: string): types.FetchOverrideRequest => ({
    type: actionTypes.FETCH_OVERRIDEREQUEST_REQUEST,
    params
});

export const getOverrideSuccess = (payload: types.FetchOverrideRequestSuccessPayload): types.FetchOverrideRequestSuccess => ({
    type: actionTypes.FETCH_OVERRIDEREQUEST_SUCCESS,
    payload
});

export const getOverrideFailure = (payload: types.FetchOverrideRequestFailurePayload): types.FetchOverrideRequestFailure => ({
    type: actionTypes.FETCH_OVERRIDEREQUEST_FAILURE,
    payload
});

//Override List
export const fetchOverrideRequestsRequest = (params: types.IOverrideRequestSearchParam): types.FetchOverrideRequestsReq => ({
    type: actionTypes.FETCH_OVERRIDEREQUEST_LIST_REQUEST,
    params: params
});

export const fetchOverrideRequestsSuccess = (payload: types.FetchOverrideRequestsSuccessPayload): types.FetchOverrideRequestsSuccess => ({
    type: actionTypes.FETCH_OVERRIDEREQUEST_LIST_SUCCESS,
    payload
});

export const fetchOverrideRequestsFailure = (payload: types.FetchOverrideRequestsFailurePayload): types.FetchOverrideRequestsFailure => ({
    type: actionTypes.FETCH_OVERRIDEREQUEST_LIST_FAILURE,
    payload
});